import { connect } from 'react-redux'
import { DeliveryOptionsComponent } from './DeliveryOptionsComponent'
import {
    deliveryReset,
    fetchDeliveryPageData,
    sendDeliveryEmail
} from 'shared/store/delivery'
import type { FormDelivery } from 'shared/types'
import type { RootState } from 'shared/store/reducers'
import type { Dispatch } from 'redux'
import type { EventMetadata } from 'shared/store/metadata'
import { eventMetadata } from 'shared/store/metadata'

const mapDispatchToProps = (d: Dispatch<any>) => ({
    fetchDeliveryPageData: () => d(fetchDeliveryPageData()),
    sendMeta: (meta: EventMetadata) => d(eventMetadata(meta)),
    sendEmail: (form: FormDelivery) => d(sendDeliveryEmail(form)),
    reset: () => d(deliveryReset())
})

const mapStateToProps = (state: RootState) => {
    return {
        ...state.deliveryPageState,
        ...state.storeLocatorPageState
    }
}

const DeliveryOptions = connect(
    mapStateToProps,
    mapDispatchToProps
)(DeliveryOptionsComponent)

export { DeliveryOptions }
